import { CurrencyApi } from '../api-typings/common/common';
import { Currency, CurrencyAjax } from './currency.model';

export function transformCurrency(currency: CurrencyApi): Currency {
  return {
    code: currency.code,
    country: currency.country,
    exchangeRate: currency.exchange_rate,
    id: currency.id,
    name: currency.name,
    sign: currency.sign,
  };
}

export function transformCurrencyAjax(currency: CurrencyAjax): Currency {
  return {
    code: currency.code,
    country: currency.country,
    exchangeRate: Number(currency.exchangerate),
    id: Number(currency.id),
    name: currency.name,
    sign: currency.sign,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/ko/webapp/src/app/@shared/datastore/currency/currency.transformers.ts